import React from 'react';

const OverviewStats = ({ stats = [], className = '', show = true }) => {
  if (!show || !stats || stats.length === 0) {
    return null;
  }

  const getGridCols = (count) => {
    if (count === 1) return 'grid-cols-1';
    if (count === 2) return 'grid-cols-1 md:grid-cols-2';
    if (count === 3) return 'grid-cols-1 md:grid-cols-3';
    if (count === 4) return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
    if (count === 5) return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-5';
    return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'; // Default fallback
  };

  return (
    <div className={`grid ${getGridCols(stats.length)} gap-6 ${className}`}>
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        const iconColor = stat.iconColor || 'text-blue-500';
        const valueColor = stat.valueColor || 'text-gray-900';
        const labelColor = stat.labelColor || 'text-gray-600';
        
        return (
          <div 
            key={stat.key || index} 
            className="bg-white rounded-xl shadow-sm p-6 border border-gray-200 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className={`text-sm font-medium ${labelColor} mb-1`}>
                  {stat.label}
                </p>
                <div className="flex items-baseline space-x-1">
                  <p className={`text-3xl font-bold ${valueColor}`}>
                    {stat.value}
                  </p>
                  {stat.suffix && (
                    <span className={`text-lg ${stat.suffixColor || 'text-gray-500'}`}>
                      {stat.suffix}
                    </span>
                  )}
                </div>
                {stat.subtitle && (
                  <p className="text-xs text-gray-500 mt-1">
                    {stat.subtitle}
                  </p>
                )}
              </div>
              {Icon && (
                <div className="ml-4">
                  <Icon className={`w-8 h-8 ${iconColor}`} />
                </div>
              )}
            </div>
            {stat.trend && (
              <div className="mt-3 flex items-center space-x-1">
                <span className={`text-xs font-medium ${
                  stat.trend.direction === 'up' ? 'text-green-600' : 
                  stat.trend.direction === 'down' ? 'text-red-600' : 
                  'text-gray-600'
                }`}>
                  {stat.trend.direction === 'up' ? '↗' : stat.trend.direction === 'down' ? '↘' : '→'} 
                  {stat.trend.value}
                </span>
                <span className="text-xs text-gray-500">
                  {stat.trend.label}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OverviewStats;